<template>
  <div class="email-content">
    <div class="link">
      <span class="icon-text">
        <font-awesome-icon icon="link"></font-awesome-icon>
      </span>
      <span class="email-text">{{email}}</span>
    </div>

    <ul class="ul">
      <div
        v-if="isEdit"
        class="edit-button">
        <span class="li"></span>
        <v-button @click="handleChange(1)">change</v-button>
      </div>
      <li
        v-for="(item,index) in companies"
        :key="index"
        class="email-li"
        :class="{'first-li':!isEdit&&index==0}"
      >
        <span class="li"></span>
        <span class="flex flex-unlink">
          <a
            class="name"
            :class="{'current-email':item.customer_id==customerId,'blue-text':isLink}"
            @click="handleLink(item)">
            {{item.company_name}}
          </a>
          <span v-if="item.customer_id==customerId&&isEdit">
            <v-button
              class="unlink-button"
              @click="handleChange(2)">
              <span class="flex">
                <font-awesome-icon icon="unlink"></font-awesome-icon>
                <span>Unlink</span>
              </span>
            </v-button>
          </span>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'email-tree',
  props:{
    companies:{
      type:Array,
      default:()=>([])
    },
    email:{
      type:String,
      default: ''
    },
    customerId:{
      type:[String,Number],
      default: ''
    },
    isLink:{
      type:Boolean,
      default:false
    },
    isEdit:{
      type:Boolean,
      default:false
    },
  },
  methods:{
    handleLink({customer_id}){
      // :to="isLink?({path:'/accounts/detail',query:{customer_id:item.customer_id}}):''"
      if(!this.isLink)
        return
      setTimeout(()=>{
        this.$router.push({
          path:'/accounts/detail',
          query:{customer_id}
        })
        this.$emit('handleLink')
      })
    },
    handleChange(type){
      this.$emit('changeType',type)
    }
  }
}
</script>

<style scoped lang="scss">
  .email-content {
    margin-left: 15px;
    .link {
      display: flex;
      align-items: center;
      .icon-text {
        width: 26px;
        height: 26px;
        font-style: normal;
        font-weight: 900;
        font-size: 14px;
        line-height: 16px;
        background: #6F42C1;
        border-radius: 26px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        color: #FFFFFF;
        margin-right: 12px;
        margin-left: -13px;
      }
      .email-text{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #6F42C1;
      }
    }
    .edit-button{
      display: flex!important;
      border-left: 2px solid #444D56;
      padding-bottom: 9px;
      .li{
        margin-right: 25px;
      }
      .el-button{
        background: #FAFBFC;
        border: 1px solid rgba(27, 31, 35, 0.15);
        box-sizing: border-box;
        box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
        border-radius: 6px;
        color: #24292E;
      }
    }
    .ul {
      margin-top: 6px;
      list-style: none;
      display: inline-flex;
      flex-direction: column;
      .email-li {
        /*display: -ms-inline-flexbox;*/
        /*min-height: 21px;*/
        /*align-items: baseline;*/
        /*border-left: 2px solid #444D56;*/
        align-items: baseline;
        display: flex;
        padding-bottom: 9px;
        border-left: 2px solid #444D56;
        &:last-child{
          border: 0!important;
         .li{
           margin-left: 0;
         }
        }
        &.first-li {
          /*min-height: 21px!important;*/
          .name {
            /*color: #22863A;*/
            color: #6A737D;
            &.current-email{
              color: #24292E;
            }
          }
          /*.li{*/
          /* height: 15px!important;*/
          /*}*/
        }
        .inline-flex{
          display: inline-flex;
          align-items: baseline;
        }
        .li {
          position: relative;
          display: block;
          width: 30px;
          height: 21px;
          border: 2px solid #444D56;
          border-top: 0;
          border-right: 0;
          margin-left: -2px;
          border-bottom-left-radius: 6px;
          margin-right: 12px;

        }

        .name {
          position: relative;
          bottom: -3px;
          word-break: break-word;
          font-size: 12px;
          line-height: 18px;
          color: #6A737D;
          text-decoration: none;
          padding-right: 20px;
          &.blue-text{
            color: #0366D6;
            cursor: pointer;
          }
          &.current-email{
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #24292E!important;
          }
        }
        .flex-unlink{
          display: flex;
          flex-direction: column;
          width: 88%;
          /*margin-left: 42px;*/
          .unlink-button{
            margin-top: 6px;
            background: #FAFBFC;
            border: 1px solid rgba(27, 31, 35, 0.15);
            box-sizing: border-box;
            box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
            border-radius: 6px;
            .flex{
              font-weight: 600;
              font-size: 12px;
              line-height: 18px;
              display: flex;
              align-items: center;
              color: #D73A49;
              span{
                margin-left: 5px;
              }
            }

          }
        }
      }

    }
  }
</style>
